<template>
  <my-view :SaveFindPass="SaveFindPass" :FindPassSendVerCode="FindPassSendVerCode"></my-view>
</template>

<script>
import {
  SaveFindPass,
  FindPassSendVerCode,
} from "@/pages/page1/api/modules/login";

import MyView from "@/pages/publicView/login/retrievePwd_view.vue";

export default {
  components: { MyView },
  data() {
    return {
      SaveFindPass,
      FindPassSendVerCode,
    };
  },
};
</script>